export default {
  oauth2: {
    clientId: '996796399167-08nougiief03k3r7tcrmtpkf3kfu7c3i.apps.googleusercontent.com'
  }
};
